import { useParams } from 'react-router-dom'
import { ROUTE_CONFIG } from '@config/routes'
import ScreenWrapper from '../layout/ScreenWrapper'
import NotFound from './NotFound'

export default function StaticPageHandler () {
  const { page } = useParams()

  if (!ROUTE_CONFIG[page]) {
    return (
      <div className='app-layout'>
        <ScreenWrapper currentPage='not-found'>
          <NotFound />
        </ScreenWrapper>
      </div>
    )
  }

  const PageComponent = ROUTE_CONFIG[page].component
  return (
    <div className='app-layout'>
      <ScreenWrapper currentPage={page}>
        <PageComponent />
      </ScreenWrapper>
    </div>
  )
}
